module.exports = "//public.getcloudapp.com/packs/media/images/annotate/text-bf482274bb83e58bdbefce439003cbe3.svg";